'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _basePanZoom = require('@bibliocommons/base-pan-zoom');

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

var _utilsHttp = require('@bibliocommons/utils-http');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SCALE_FACTOR = 5;

var ZoomableMapDisplay = function (_BcReactComponent) {
  _inherits(ZoomableMapDisplay, _BcReactComponent);

  function ZoomableMapDisplay(props) {
    _classCallCheck(this, ZoomableMapDisplay);

    var _this = _possibleConstructorReturn(this, (ZoomableMapDisplay.__proto__ || Object.getPrototypeOf(ZoomableMapDisplay)).call(this, props));

    _this.state = {
      x: 0,
      y: 0,
      scale: 1
    };
    _this.bindAll('handleMapUpdate', 'handleZoomIn', 'handleZoomOut', 'handlePrint');
    return _this;
  }

  _createClass(ZoomableMapDisplay, [{
    key: 'handleMapUpdate',
    value: function handleMapUpdate(obj) {
      this.setState(obj);
    }
  }, {
    key: 'handleZoomIn',
    value: function handleZoomIn() {
      this.setState({
        scale: Math.min(MAX_SCALE_FACTOR, this.state.scale + 0.5)
      });
    }
  }, {
    key: 'handleZoomOut',
    value: function handleZoomOut() {
      var newScale = Math.max(1, this.state.scale - 0.5);
      this.setState({
        scale: newScale,
        x: newScale !== 1 ? this.state.x : 0,
        y: newScale !== 1 ? this.state.y : 0
      });
    }
  }, {
    key: 'handlePrint',
    value: function handlePrint() {
      var queryString = (0, _utilsHttp.createQueryString)({
        callno: this.props.callno,
        library: this.props.library,
        location: this.props.location,
        v: 'pf'
      });
      var pfUrl = 'https://' + this.props.domain + '.stackmap.com/view/?' + queryString;
      window.open(pfUrl, 'stackmap', 'width=950,height=800,toolbar=no,directories=no,scrollbars=1,location=no,menubar=no,status=no,left=0,top=0');
      return false;
    }
  }, {
    key: 'renderRanges',
    value: function renderRanges() {
      var map = this.props.map;

      return _react2.default.createElement(
        'ul',
        { className: 'stackmap-ranges' },
        map.get('ranges').map(function (range) {
          return _react2.default.createElement(
            'li',
            { className: 'stackmap-range', key: range.get('rangename') },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'stackmap_range_info', values: { rangename: range.get('rangename'), callnoDisplay: range.get('callnoDisplay') } })
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var map = this.props.map;
      return _react2.default.createElement(
        'div',
        { className: 'stackmap-text' },
        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'stackmap_general_info', values: { floorname: map.get('floorname'), library: map.get('library') } }),
        !this.props.hideRanges && this.renderRanges(),
        _react2.default.createElement(
          'div',
          { className: 'stackmap-buttons' },
          _react2.default.createElement(
            _baseButtons.DefaultButton,
            { handleClick: this.handleZoomIn, 'data-test-id': 'zoom-in' },
            _react2.default.createElement(
              _baseIcons.IconWithBackground,
              { icon: _react2.default.createElement(_baseIcons.Plus, null), bgColor: '#02729e' },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'stackmap_zoom_in' })
            )
          ),
          _react2.default.createElement(
            _baseButtons.DefaultButton,
            { handleClick: this.handleZoomOut, 'data-test-id': 'zoom-out' },
            _react2.default.createElement(
              _baseIcons.IconWithBackground,
              { icon: _react2.default.createElement(_baseIcons.Minus, null), bgColor: '#02729e' },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'stackmap_zoom_out' })
            )
          ),
          _react2.default.createElement(
            _baseButtons.DefaultButton,
            { tagName: 'a', href: '#print-view', handleClick: this.handlePrint },
            _react2.default.createElement(
              _baseIcons.IconWithBackground,
              { icon: _react2.default.createElement(_baseIcons.Printer, { color: 'currentColor' }), bgColor: '#02729e' },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'print' })
            )
          )
        ),
        _react2.default.createElement(
          _basePanZoom.PanZoom,
          _extends({ handleUpdate: this.handleMapUpdate, className: 'stackmap-image-container' }, this.state, { height: map.get('height'), width: map.get('width'), maxScale: MAX_SCALE_FACTOR }),
          _react2.default.createElement('img', { className: 'stackmap-image', alt: '', src: map.get('mapurl') + '&marker=1' })
        ),
        map.get('directions') ? _react2.default.createElement(
          'div',
          { className: 'stackmap-directions' },
          _react2.default.createElement(
            _reactIntl.FormattedMessage,
            { id: 'stackmap_directions' },
            function (message) {
              return _react2.default.createElement(
                'h3',
                null,
                message
              );
            }
          ),
          map.get('directions')
        ) : null
      );
    }
  }]);

  return ZoomableMapDisplay;
}(_baseBcReactComponent2.default);

ZoomableMapDisplay.propTypes = {
  isFetching: _react.PropTypes.bool,
  noResults: _react.PropTypes.bool,
  hideRanges: _react.PropTypes.bool,
  maps: _reactImmutableProptypes2.default.mapContains({
    directions: _react.PropTypes.string,
    floorname: _react.PropTypes.string,
    height: _react.PropTypes.number,
    width: _react.PropTypes.number,
    ranges: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
      callnoDisplay: _react.PropTypes.string,
      rangename: _react.PropTypes.string
    }))
  })
};

exports.default = ZoomableMapDisplay;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/stackmap/lib/components/zoomable-map-display/components/ZoomableMapDisplay.js
// module id = 1545
// module chunks = 1